// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom_checkbox_margin > .v-input--selection-controls.v-input {\n  margin: 0px !important;\n}\n.custom_border {\n  border: 1px solid #ada9a9;\n  padding: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
